import React, { useState } from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router'
import {rjscSearchResultSelect} from '../../redux/selector/rjscSearchSelector'
import {
    Header, 
    Paragraph,
    Button,
    ErrorMark
} from '../../components/RegularComponents'
import TopNavigationBar from '../TopNavigationBar';
import { replaceUrlParams } from '../../app/utils';
import Navigation from '../Navigation';
import { Pagination } from '../../components/Pagination/Pagination'
import { fetchOperatingBusinessData, fetchRjscFromNumberAndSetDetails, setRjscAdvanceSearchString } from '../../redux/slice/rjscSearchSlice';
import { ROUTE_PATH } from '../../app/constants';

const RJSCSearchResult = (props) => {
    const {rjscSearchResult, dispatch} = props
    const{applicationType, applicationMode} = props.match.params
    const defaultRegistryNumber = rjscSearchResult.companyRjscRegistryNumber ? 
                                    rjscSearchResult.companyRjscRegistryNumber : 
                                    rjscSearchResult.searchResponseData ? rjscSearchResult.searchResponseData[0]?.businessEntity?.registryNumber : ""

    const [rjscSearchRegistryNumber, setRjscSearchRegistryNumber] = useState(defaultRegistryNumber)

    const [currentPage, setCurrentPage] = useState(1)
    const [showError, setShowError] = useState(false)
    const [fetchingRjscDetails, setFetchingRjscDetails] = useState(false)

    const itemsPerPage = 100

    /* There are two paths from here : 
     1. If the search is with the rjsc number : 
          - Assumption here is that the selected business is already 
            the operating business.
     2. If the search is with rjsc name :
          - The selected name is legal name. 
          - We need to search the operating business names for the selected entity.
          - There are three options from here : 
              - A. There are no operating businesses
                    - Keep the selected legal name as operating business 
              - B. There is exactly one operating business
                    - Keep the single operating business as the operating business
              - C. There are multiple operating businesses
                    - Show all options and let user select the operating business
    */  
    const onNextClick = () => {

        setFetchingRjscDetails(true)

        const searchResultItem = currentPageItems().find(item => item.registryNumber === rjscSearchRegistryNumber)
        
        // if the selected search is name search : 
        if(1 || (rjscSearchResult.searchType === "rjscSearchName" || 
            (searchResultItem && searchResultItem.isParentEntity))) {
            dispatch(setRjscAdvanceSearchString({searchText : rjscSearchRegistryNumber})) 
            dispatch(fetchOperatingBusinessData(rjscSearchRegistryNumber, "rjscSearchName"))
                .then(data => {
                    // TODO : check the size of this response.
                    dispatch(push(replaceUrlParams(
                        ROUTE_PATH.RJSC_OPERATING_NAME_SEARCH_SELECT, 
                        applicationType, 
                        applicationMode)))
                })
        } else {
            dispatch(fetchRjscFromNumberAndSetDetails(rjscSearchRegistryNumber))
            .then((data) => {
              dispatch(push(replaceUrlParams(
                  rjscSearchResult.navigation.next, 
                  applicationType, 
                  applicationMode)))
              }
            )
            .catch(err => {
                setShowError(true)
            })
        }
    }

    const currentPageItems = () => {
        if(!rjscSearchResult || !rjscSearchResult.searchResponseData)
            return []
        
        let startIndex = ((currentPage - 1) * itemsPerPage)
        return rjscSearchResult.searchResponseData.slice(startIndex, startIndex + itemsPerPage)
    }

    const totalPages = () => {
        if(!rjscSearchResult || !rjscSearchResult.searchResponseData)
            return 0

        return (parseInt(rjscSearchResult.searchResponseData.length / itemsPerPage) 
            + ((rjscSearchResult.searchResponseData.length % itemsPerPage > 0) ?  1 : 0 ))
    }

    return (
    <>
        <Navigation {...props} />
        <div className="container">
            <TopNavigationBar {...props} />
            <div className="row">
                <div className="col-lg-8">
                    <Header 
                        id="rjs-search-results-header" 
                        header={rjscSearchResult.header} />
                    <Paragraph 
                        id="rjsc-search-results-text"
                        text={rjscSearchResult.text} />
                </div>
            </div>

            {fetchingRjscDetails ? 
                (<div className="row">
                    <div className="col-12 centered">
                        <p className="statusText">
                            fetching data...
                        </p>
                    </div>
                </div>) : 
                (<div className={"row"}>
                    <div className={"col-8"}>
                        <fieldset className="ns-fieldset">
                            <div className={"ns-radios ns-radios--small"}>
                                {currentPageItems().map(d => {
                                    // const {registryNumber, entityId, businessName} = d.businessEntity
                                    const {registryNumber, entityId, businessName} = d
                                    
                                    return (
                                        <div key={entityId} className="ns-radios__item">
                                            <input 
                                                className="ns-radios__input"
                                                key={entityId + "-input"}
                                                type={"radio"} 
                                                value={registryNumber} 
                                                checked={(rjscSearchRegistryNumber === registryNumber)}
                                                onChange={(e) => setRjscSearchRegistryNumber(e.target.value)}
                                                id={"rjsc-search-result-"+entityId + "-input"} 
                                                name={"rjsc-search-result-"+entityId + "-input"} 
                                            />
                                            <label 
                                                key={entityId + "-label"}
                                                id={"rjsc-search-result-"+entityId + "-label"}
                                                className="ns-radios__label"
                                                htmlFor={"rjsc-search-result-"+entityId + "-input"}>
                                                    <span className="ns-label-span">
                                                        {`${businessName} (# ${registryNumber})`}
                                                    </span>
                                            </label>
                                        </div>
                                    )
                                })}
                            </div>
                        </fieldset>
                    </div>
                </div>)
            }

            {totalPages() > 1 ? 
                <div className="row">
                    <div className="col-8">
                        <Pagination 
                            totalPages={totalPages()}
                            currentPage={currentPage}
                            onPageChange={(pageNum) => {
                                setCurrentPage(pageNum)
                            }}
                        />
                    </div>
                </div> : null
            }
            
            
            <div className="row bottomMarginNormal">
                <div className={"col-lg-4" + (showError ? " has-error" : "")}>
                    <Button 
                        showSpinner={fetchingRjscDetails}
                        id="rjsc-search-result-button"
                        text={"Next"}
                        buttonType={"regular_primary"}
                        style={{marginTop: "15px"}}
                        onClick={onNextClick}
                    />
                    {showError && ErrorMark()}
                </div>
            </div>
            {showError && 
            <div className="ns-error-message help-block">
                {"Could not find RJSC details"}
            </div>}
        </div>
    </>
    )
}

export default connect(rjscSearchResultSelect) (RJSCSearchResult)
